"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var config_context_1 = require("../../_util/config-context");
var AndroidGuide = function (props) {
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { id: "android-download-guide-launch", className: "".concat(classPrefix, "-android-download-container"), onClick: props.closeAndrGuide },
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-arrow-img") }),
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-hint-container") },
            react_1.default.createElement("div", null, t('请点击右上角的...')),
            react_1.default.createElement("div", null, t('选择在默认浏览器中打开')))));
};
exports.default = AndroidGuide;
//# sourceMappingURL=andr-download.js.map